<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value"
                :label="label"
                append-icon="mdi-clock-outline"
                readonly
                v-bind="{...attrs, ...$attrs}"
                clearable
                v-on="on"
            ></v-text-field>
        </template>
        <v-time-picker
            v-if="menu"
            :value="value"
            full-width
            @input="$emit('input', $event)"
            @click:minute="$refs.menu.save(time)"
        ></v-time-picker>
    </v-menu>
</template>

<script>
export default {
    name: "PTimePicker",
    props: {
        label: String,
        value: String
    },
    data() {
        return {
            time: "",
            menu: false
        }
    }
}
</script>

<style>

</style>